import React, { useEffect, useState } from 'react';
import { getBasLabels } from '../../../utils/commonUtils';
import './SelectDistributorModal.scss';
import GoogleMapComponent from '../../GoogleMapComponent/GoogleMapComponent';
import AnimatedButton from '../../atoms/AnimatedButton/AnimatedButton';
import { useAppUiStore } from '../../../hooks/useStores';
import { windowWidth } from '../../../utils/commonUtils';

export default function SelectDistributorModal({
  handleCloseModal,
  dealersList,
  setShowDistributorModal,
}) {
  const labels = getBasLabels();
  let dealershipCount = 0;

  const [selectedDealer, setSelectedDealer] = useState(windowWidth < 768 ? -1 : 0);
  const [markerLocations, setMarkerLocations] = useState([]);
  const [showDealerModalMobParent, setShowDealerModalMobParent] = useState(false);
  const { uiStore } = useAppUiStore();

  useEffect(() => {
    if (dealersList.length > 0) {
      setMarkerLocations([]);
      dealersList.forEach((dealer) => {
        setMarkerLocations((prev) => [...prev, dealer]);
        return null; // Return null to avoid unnecessary re-rendering of the map component.
      });
    }
  }, []);

  const handleKeyPress = (event, index) => {
    if (event.key === 'Enter' || event.key === ' ') {
      setSelectedDealer(index);
    }
  };

  const dealerSelected = (e, dealer) => {
    console.log(dealer);
    uiStore.updateDealerSelectionBAS(dealer);
    setShowDealerModalMobParent(false);
    setShowDistributorModal(false);
  };

  const updateSelection = (i) => {
    if (windowWidth < 768) {
      document.querySelector('.modal_content').scrollTop = 0;
    }
    setSelectedDealer(i);
  };

  return (
    <div className="select_distributor_modal">
      <span className="select_distributor_heading">{labels.dealerListTitle}</span>
      <div className="distributor_view_container">
        <div className="distributor_list">
          {dealersList?.map((dealer, i) => {
            return (
              dealer.ServiceAddressStreet &&
              dealer?.HasServiceAddress === '1' &&
              ++dealershipCount && (
                <div
                  key={dealer.DealerCode}
                  className={`dealer_item ${selectedDealer === i ? 'active' : ''}`}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => handleKeyPress(e, i)}
                  onClick={() => updateSelection(i)}>
                  <div className="details_wrapper">
                    <div className="dealer_details_container">
                      <span className="dealer_name">{dealer.Name}</span>
                      <span className="dealer_details">
                        {`${dealer.ServiceAddressStreet.toLowerCase()}`} <br />{' '}
                        {`${dealer.ServiceAddressCity.toLowerCase()}`} <br />{' '}
                        {`${dealer.ServiceAddressPostalCode}`} <br /> {`${dealer.Phone}`}
                      </span>
                    </div>
                    <div className="pin_container">
                      <img
                        className="location_pin"
                        alt=""
                        src={`${selectedDealer === i ? '/assets/feature/genesis/buildandorder/assets/images/location-pin-black.svg' : '/assets/feature/genesis/buildandorder/assets/images/location-pin.svg'}`}></img>
                      <span className="circle_num">{dealershipCount}</span>
                      <span className="distance">
                        {parseFloat(dealer.DistinaceInKilometers).toFixed(1)} km
                      </span>
                    </div>
                  </div>
                  {selectedDealer === i && windowWidth >= 768 && (
                    <div className="select_dealer_wrapper">
                      <AnimatedButton
                        text={labels.selectLabel}
                        theme="white"
                        clickHandler={dealerSelected}
                        activeClass="active"
                        itemData={dealer}
                      />
                    </div>
                  )}
                </div>
              )
            );
          })}
        </div>

        {/* Render Map */}
        <GoogleMapComponent
          markerLocations={markerLocations}
          selectedDealer={selectedDealer}
          setShowDistributorModal={setShowDistributorModal}
          resetSelectedDealerMob={setSelectedDealer}
          showDealerModalMobParent={showDealerModalMobParent}
        />
      </div>
    </div>
  );
}
